// extracted by mini-css-extract-plugin
export default {"baseButton":"button_baseButton__yxrc9","disabled":"button_disabled__ZFO7n","large":"button_large__5+HTw","primary":"button_primary__mSEtU","secondary":"button_secondary__ZKgSm"};